import { Checkbox, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import debounce from 'lodash.debounce';
import React, { useCallback, useState } from 'react'
import { actualizarRolesYDepartamentos } from '../../../services/apis';

export const PermisosOpciones = ({ roles, opciones, title, nombreArray }) => {
    // Estado local para opciones con roles_permitidos
    const [opcionesTempOG, setOpcionesTempOG] = useState([...opciones]);
    const [opcionesTemp, setOpcionesTemp] = useState([...opciones]);

    const [nombreOpciones, setNombreOpciones] = useState([...opciones])

    // Función para manejar el cambio en los permisos
    const handleCheckboxChange = (rolId, opcionId) => {
        // Actualizar el estado de las opciones al cambiar el checkbox
        const updatedOpciones = opcionesTemp.map((opcion) => {
            if (opcion.id === opcionId) {
                // Verificar si el rol ya está presente en roles_permitidos
                const isRolPresent = opcion.roles_permitidos.includes(rolId);
                // Si el rol está presente, lo eliminamos; si no, lo agregamos
                const updatedRolesPermitidos = isRolPresent
                    ? opcion.roles_permitidos.filter((id) => id !== rolId) // Eliminar rol
                    : [...opcion.roles_permitidos, rolId]; // Añadir rol
                return { ...opcion, roles_permitidos: updatedRolesPermitidos }; // Actualizamos la opción
            }
            return opcion; // Si no es la opción que se ha modificado, la dejamos igual
        });
        setOpcionesTemp(updatedOpciones);
        debouncedHandleSearch(updatedOpciones, rolId);
    };

    const actualizarPermisos = async (updatedOpciones, rolid) => {

        try {
            const response = await actualizarRolesYDepartamentos(updatedOpciones, nombreArray, rolid);

        } catch (error) {
            console.error('Error al cargar las opciones:', error);
        }
    }
    const debouncedHandleSearch = useCallback(debounce(actualizarPermisos, 1000), []);


    const buscarOpcion = (event) => {
        console.log("Buscando opción:", event.target.value.toLowerCase());

        const searchTerm = event.target.value.toLowerCase();

        if (searchTerm === "") {
            // Si el campo de búsqueda está vacío, puedes restaurar la lista original
            // Por ejemplo:
            setOpcionesTemp(opcionesTempOG);
            setNombreOpciones(opcionesTempOG);
            return;
        }

        const resultados = opcionesTempOG.filter(opcion => {
            return (
                opcion.nombre.toLowerCase().includes(searchTerm)
            );
        });

        const resultados2 = opciones.filter(opcion => {
            return (
                opcion.nombre.toLowerCase().includes(searchTerm)
            );
        });

        setNombreOpciones(resultados2);
        // Actualiza el estado con los resultados
        // Por ejemplo:
        setOpcionesTemp(resultados2);
        console.log("Resultados de búsqueda:", resultados);
    }


    return (
        <>
            {opciones && opciones.length >= 1 && (
                <Grid container direction={'row'}
                size={{ xs: 12 }}
                sx={{ justifyContent: 'center', alignItems: 'center' }}>
                    <Grid container direction={'column'}
                size={{ xs: 12 }}
                sx={{ justifyContent: 'center', alignItems: 'center' }}>
                        <Typography variant='h4' sx={{ mt: 4, mb: 2 }}>
                            {title}
                        </Typography>

                    </Grid>
                    <Grid container direction={'column'}
                size={{ xs: 11.5, sm: 11, md: 10 }}
                sx={{ justifyContent: 'center', alignItems: 'center' }}>
                        {
                            opcionesTempOG.length > 10
                                ? <Grid container sx={{ mb: 2 }}
                size={{ xs: 12 }}>
                                    <TextField id="standard-basic" label="Buscar..." variant="standard" size="small" name='search' fullWidth onChange={(event) => buscarOpcion(event)} />
                                </Grid>
                                : <></>
                        }

                        <TableContainer component={Paper} sx={{ minWidth: "100%" }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: '#e53935' }}>
                                        <TableCell>
                                            <Typography variant='h6' sx={{ fontSize: 25, color: 'white' }}>
                                                Roles
                                            </Typography>
                                        </TableCell>
                                        {nombreOpciones.map((opcion) => (
                                            <TableCell key={opcion.id} align="center">
                                                <Typography variant='h6' sx={{ fontSize: 15, color: 'white' }}>
                                                    {opcion.nombre}
                                                </Typography>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {/* Filas de roles */}
                                    {roles.map((rol, indexRol) => (
                                        <TableRow key={rol.id} sx={{ backgroundColor: indexRol % 2 === 0 ? '#ffffff' : '#f7e2e1' }}>
                                            <TableCell>
                                                <Typography variant='h6' sx={{ fontSize: 20 }}>
                                                    {rol.nombre}
                                                </Typography>
                                            </TableCell>
                                            {opcionesTemp.map((opcion) => (
                                                <TableCell key={`${rol.id}-${opcion.id}`} align="center">
                                                    <Checkbox
                                                        checked={opcion.roles_permitidos.includes(parseInt(rol.id))} // Verificar si el rol está en roles_permitidos
                                                        onChange={() => handleCheckboxChange(parseInt(rol.id), opcion.id)} // Manejar el clic
                                                    />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>

                </Grid>
            )}
        </>
    );
};
